<template>
  <div>
    <div class="text-center mt-0 mb-3" v-if="Caricatoqui == false">
        <b-spinner
            variant="primary"
            style="width: 2.5rem; height: 2.5rem;"
            class="mr-1"
            label="loading"
        />
    </div>

    <div v-else>
      <div v-if="this.testata_nome_pacchetto">
        <h3 class="mb-1">{{ this.testata_nome_pacchetto }}</h3>
        <h6 class="mb-3">
          <span v-if="this.field_split_payment == 'No'">
            <span v-if="this.field_vat_scheme_id == 1">
            Importo totale: {{ prezzoFormattatoStripeQUI(this.testata_prezzo_pacchetto, 1) }}
            </span>
            <span v-else>
              Importo totale: {{ prezzoFormattatoStripeQUI(this.testata_prezzo_pacchetto, 0) }}
            </span> 
          </span>
          <span v-else>
            Importo totale: {{ prezzoFormattatoStripeQUI(this.testata_prezzo_pacchetto, 0) }}
          </span>
        </h6>
      </div>
          
    </div>

    <form @submit.prevent="handlePayment">
      <!-- Elemento Stripe Payment Element -->
      <div id="payment-element"></div>

      <!-- Errori di pagamento -->
      <p v-if="errorMessage" class="error">{{ errorMessage }}</p>

      <div v-if="isButtonVisible" class="mt-2">
        <b-button 
          variant="outline-primary" 
          class="text-uppercase mb-3" 
          type="submit" 
          :disabled="isLoading || !isFormValid"
        >
          
          <div v-if="isLoading">Aggiornamento in corso <b-spinner small class="ml-1" /></div>
          <div v-else>Aggiorna metodo di pagamento</div> 
        </b-button>
      </div>


    </form>

  </div>
</template>

<script>
import { loadStripe } from '@stripe/stripe-js';
import { BButton, BSpinner } from 'bootstrap-vue'


export default {
  components: {
    BButton, 
    BSpinner, 
  },
  props: {
    field_stripe_api_key: {
      type: String,
      required: true,
    },
    field_payment_intent: {
      type: String,
      required: true,
    },
    field_license_id: {
      type: Number,
      //type: String,
      required: true,
    },
    field_customer: {
      type: String,
      required: true,
    },
    field_codice_contratto: {
      type: String,
      required: true,
    },
    field_product_id: {
      type: String,
      required: true,
    },
    field_is_subscription: {
      type: Boolean,
      required: true,
    },
    field_vat_scheme_id: {
      type: Number,
      required: true,
    },
    field_split_payment: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      Caricatoqui: false, 

      stripe: null,
      elements: null,
      paymentElement: null,
      isLoading: false,
      errorMessage: null,
      isSuccess: false,

      testata_nome_pacchetto: '',
      testata_prezzo_pacchetto: '',
      testata_iva_pacchetto: null,
      
      nome_pacchetto: '',
      price_pacchetto_stripe: '', // 'price_XXXX' - serve solo per le subscription

      isButtonVisible: false,  // Inizialmente il bottone non è visibile
      isFormValid: false, // Stato di validità del form

      selectedPaymentMethod: null,

      importo_da_tassare_su_stripe: 0, //default 0 = No, non da tassare

      clientSecretOk: '',
    };
  },
  computed: {
    formattedAmount() {
      return (this.amount / 100).toFixed(2) + ' €';
    },
  },
  async mounted() {
    console.log("Siamo in CHANGEPAYMENT.VUE - async mounted ---------------------------------")
    console.log(this.field_payment_intent)

    //caricare informazioni di default per il nome del pacchetto che andremo a pagare a prescindere dalle operazioni successive
    this.$http.get('api/customer/stripe/infolicenza/'+this.field_product_id).then(response_pacchetto => { 
      //console.log(response_pacchetto)
      //alert("NOME PACCHETTO -> "+response_pacchetto.data.reply.name)

      this.testata_nome_pacchetto = response_pacchetto.data.reply.name;
      this.testata_prezzo_pacchetto = response_pacchetto.data.reply.default_price.unit_amount;
      this.testata_iva_pacchetto = response_pacchetto.data.reply.tax_code; //se NON indicato su Stripe nella scheda del prodott è di defualt NULL

      this.Caricatoqui = true;
      
    }).catch(e => {
      console.log("Errore api recupero stripe infolicenza ......")
      console.log(e)

      this.Caricatoqui = false;
      alert("Errore nel caricamento delle informazioni del pacchetto ...")
    });

    //PAYMENT_INTENT GIA' CREATO - l'ho recuperato dal DB nella tabella Licence
    // PER FORZA COS' ESSENDO UN CAMBIO DI PAGAMENTO PER UN PAYMENT INTENT GIA' CREATO ;-)

    const dataSalvato = { clientSecret: this.field_payment_intent };
    const { clientSecret } = dataSalvato;

    if (!clientSecret) {
    throw new Error('Il clientSecret non è stato restituito dal server.');
    }

    //estrai nome dal pacchetto in fase di pagamento ...
    const response = this.$http.post('/api/customer/stripe/nome-pacchetto', 
    {
        payment_intent_secret_stripe: this.field_payment_intent,
    }
    );

    const risposta = await response

    /*
    console.log("risposta .............")
    console.log(risposta)
    console.log("dati dall'api .............")
    console.log(risposta.data.reply)
    */

    //visualizza dati
    this.nome_pacchetto = risposta.data.reply.nome_pacchetto

    // 'price_XXXX' di Stripe del pacchetto (serve in caso di subscription)
    this.price_pacchetto_stripe = risposta.data.reply.prezzo_pacchetto

    // Inizializza Stripe e gli elementi
    this.stripe = await loadStripe(this.field_stripe_api_key);
    this.elements = this.stripe.elements({ clientSecret });

    //salvo per i successivi passaggi (pagamento)
    this.clientSecretOk = this.field_payment_intent

    


    // Configura il Payment Element
    this.paymentElement = this.elements.create('payment', {
      layout: 'tabs', // Mostra i metodi di pagamento in tab
    });

    // Monta il Payment Element
    this.paymentElement.mount('#payment-element');

    // Aggiungi un listener per validare il form
    this.paymentElement.on('change', (event) => {
      this.isFormValid = !event.error && event.complete; // Abilita il bottone solo se completo e senza errori
      this.errorMessage = event.error ? event.error.message : null; // Mostra eventuali errori

      //gestione selezione metodo di pagamento
      if (event.value.type === 'card') {
        //CARTE DI CREDITO
        console.log('Carta di credito');
        this.selectedPaymentMethod = 'card';

      } else if (event.value.type === 'sepa_debit') {
        // SEPA
        console.log('SEPA');
        this.selectedPaymentMethod = 'sepa_debit';

      } else if (event.value.type === 'paypal') {
        // PAYPAL
        console.log('PAYPAL');
        this.selectedPaymentMethod = 'paypal';

      } else {
        //altro per il futuro ...
        console.log('Altro');
      }

    });

    //visualizza bottone "paga"
    console.log("visualizza bottone Paga ---")
    this.isButtonVisible = true;
    
  },
  methods: {
    prezzoFormattatoStripeQUI(prezzo, iva) {
      if (typeof prezzo === 'number') {
          if (iva == 1) {
            prezzo *= 1.22;
          }

          let prezzoStringa = (prezzo / 100).toFixed(2); // Dividiamo per 100 per ottenere il valore con due decimali
          let [prezzo_intero, prezzo_decimali] = prezzoStringa.split('.'); // Separiamo la parte intera e decimale
          let prezzo_elab = prezzo_intero + "," + prezzo_decimali; // Usando la virgola per separare i decimali
          // Aggiungiamo il separatore delle migliaia con il punto
          return prezzo_elab.replace(/\B(?=(\d{3})+(?!\d))/g, ".") + " €";
      } else {
          return "---";
      }
    },

    async createPaymentMethod() {
      try {
        const { paymentMethod, error } = await this.stripe.createPaymentMethod({
          type: 'card', // Puoi specificare altri tipi, come 'ideal' o 'bancontact'
          card: this.elements.getElement('card'), // Ottieni l'elemento card dai tuoi elementi
        });

        if (error) {
          console.error('Errore durante la creazione del metodo di pagamento:', error);
          //return null; // O gestisci l'errore come preferisci
        }

        // Associa il metodo di pagamento al cliente
        const { error: attachError } = await this.stripe.attachPaymentMethod(paymentMethod.id, {
          customer: this.field_customer, // l'ID cliente associato -> "cus_XXXXXX"
        });

        if (attachError) {
          console.error('Errore durante l\'associazione del metodo di pagamento:', attachError);
          //return null; // O gestisci l'errore come preferisci
        }

        console.log('ID del metodo di pagamento creato e associato:' + paymentMethod.id); // Restituisci l'ID del metodo di pagamento
      } catch (error) {
        console.error('Errore durante la creazione o l\'associazione del metodo di pagamento:', error);
        //return null; // O gestisci l'errore come preferisci
      }
    },
    
    async handlePayment() {
        this.isLoading = true;
        this.errorMessage = null;

        if (!this.stripe || !this.elements || !this.paymentElement) {
            this.errorMessage = 'Stripe Elements non è stato inizializzato correttamente.';
            console.error(this.errorMessage);
            this.isLoading = false;
            return;
        }

        const { paymentMethod, error } = await this.stripe.createPaymentMethod({
            type: this.selectedPaymentMethod,
            card: this.paymentElement,
        });

        if (error) {
            this.errorMessage = error.message;
            this.isLoading = false;
            return;
        }

        if (paymentMethod) {
            try {
                const response = await axios.post(`/api/customer/stripe/attach-and-confirm-payment/${this.field_payment_intent}`, {
                    payment_method_id: paymentMethod.id,
                });

                // Gestisci la risposta di successo dal backend (es. messaggio all'utente, reindirizzamento)
                console.log('Metodo di pagamento aggiornato e pagamento avviato:', response.data);
                this.isSuccess = true;
                // Potresti voler reindirizzare l'utente a una pagina di successo
            } catch (err) {
                console.error('Errore durante l\'aggiornamento del metodo di pagamento e l\'avvio del pagamento:', err.response?.data?.error || err.message);
                this.errorMessage = err.response?.data?.error || 'Errore durante l\'aggiornamento del metodo di pagamento e l\'avvio del pagamento.';
            } finally {
                this.isLoading = false;
            }
        } else {
            this.errorMessage = 'Errore durante la creazione del metodo di pagamento.';
            this.isLoading = false;
        }
    },

    
  },
};
</script>

<style>
.error {
  color: red;
  padding-top: 20px;
}
</style>
